import { useRouter } from 'next/router';
import ThePage from '@elem/compPage/Support/get-support';
import { useEffect } from 'react';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';

export default function GetSupport({ SEO }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('supportcasecreate');
    const router = useRouter();
    const { locale = 'us' } = router;
    const WHITE_SITE = ['us', 'au', 'ca', 'eu', 'uk', 'za', 'nl'];
    // @ts-ignore
    useEffect(() => {
        if (!WHITE_SITE.includes(locale)) {
            return router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={WHITE_SITE} pathname={'support/get-support'} />
            <ThePage />
        </PageLayout>
    );
}
